export default () => {
  return {
    editorIsSaving: true
  };
};
